import axiosInstance from './instance';

const popupApi = {
  fetchpopupDetail() {
    return axiosInstance.get('popup?type=APP');
  },
};

export default popupApi;
